import ApexCharts from 'apexcharts'

window.ApexCharts = ApexCharts